<template>
    <oss-dialog
        v-model="dialog"
        v-if="dialog"
        :max-width="$vuetify.display.mobile ? 'auto' : '900px'"
        :title="'Gestionnaire des t&#xe2;ches'"
        :previous-display="windowStep !== 'default'"
        @close="close()"
        @previous="previous()"
        @valid="windowStep === 'default' ? valid() : previous()"
        :validTitle="valueButton"
        :validDisabled="!isValid"
    >
        <v-window v-model="windowStep">
            <v-window-item value="default">
                <v-form v-model="taskValid">
                    <v-row no-gutters class="d-flex justify-center align-center">
                        <v-col cols="12" class="d-flex pa-1">
                            <v-text-field-filled
                                v-model="task.title"
                                label="Titre"
                                outlined
                                hide-details
                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12" class="d-flex pa-1">
                            <v-col :disabled="readOnly" cols="6" class="d-flex pa-1">
                                <ossCompanySelector
                                    v-model="task.client"
                                    :items="allAvailableCompanies"
                                    :selectClass="'oss-dark'"
                                    :readonly="readOnlyFieldDialog()"
                                    :disabled="readOnly"
                                    :chipMaxLength="9"
                                />
                            </v-col>
                            <v-col cols="6" class="d-flex pa-1" v-if="isEditTaskReceive">
                                <v-text-field-filled
                                    label="Créé par"
                                    outlined
                                    :readonly="true"
                                    hide-details
                                    :model-value="formatUserTaskFrom(task.owner)"
                                    density="compact"
                                />
                            </v-col>
                        </v-col>
                        <v-col class="d-flex pa-1" cols="12" @click="openUsersChoice">
                            <v-combobox-filled
                                v-model="selectedUsers"
                                :items="selectedUsers"
                                item-value="id"
                                :item-title="(item) => getUserDisplayName(item)"
                                label="Choix Collaborateur"
                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                dense
                                readonly
                                outlined
                                chips
                                multiple
                                :disabled="readOnly"
                            />
                        </v-col>
                        <v-col class="d-flex pa-1" cols="3">
                            <v-select-filled
                                v-model="task.periodicity"
                                label="Récurrence"
                                :items="periodicity"
                                :readonly="readOnlyFieldDialog()"
                                :disabled="readOnly"
                                item-value="value"
                                outlined
                                density="compact"
                                :item-title="(item) => item.name"
                            />
                        </v-col>
                        <v-col class="d-flex pa-1" cols="3">
                            <oss-date-picker-filled
                                v-if="!checkPeriodicity()"
                                v-model="task.dueDate"
                                :label="'&#xc9;chéance'"
                                :textFieldReadOnly="false"
                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                :disabled="readOnly"
                            />
                        </v-col>
                        <v-col class="d-flex pa-1" cols="3">
                            <oss-date-picker-filled
                                v-if="checkPeriodicity()"
                                v-model="task.start"
                                :label="'Début de récurrence'"
                                :textFieldReadOnly="false"
                                :disabled="readOnly"
                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                            />
                        </v-col>
                        <v-col class="d-flex pa-1" cols="3">
                            <oss-date-picker-filled
                                v-if="checkPeriodicity()"
                                v-model="task.end"
                                :notRequired="true"
                                :label="'Fin de récurrence'"
                                :textFieldReadOnly="false"
                                :disabled="readOnly"
                            />
                        </v-col>
                        <v-col class="d-flex pa-1" cols="6">
                            <v-select-filled
                                v-model="task.type"
                                label="Type de t&#xe2;che"
                                :items="type"
                                item-value="value"
                                :readonly="readOnlyFieldDialog()"
                                :disabled="readOnly"
                                outlined
                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                density="compact"
                                :item-title="(item) => item.name"
                            />
                        </v-col>
                        <v-col class="d-flex pa-1" cols="6">
                            <v-select-filled
                                v-model="task.status"
                                label="Statut"
                                :items="typeStatus"
                                item-value="value"
                                outlined
                                :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                density="compact"
                                :item-title="(item) => item.name"
                            />
                        </v-col>
                        <v-col class="d-flex pa-1" cols="12">
                            <v-text-field-filled
                                v-model="task.description"
                                label="Description"
                                outlined
                                clearable
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-window-item>
            <v-window-item value="usersChoice">
                <v-row no-gutters class="d-flex justify-center align-center">
                    <v-col class="pt-2">
                        <select-user
                            class="px-1"
                            v-model="selectedUsers"
                            :companyId="companyId"
                            :type="'NATURAL_PERSON'"
                            :withEmail="true"
                            :multiple="true"
                            v-model:step="selectUserStep"
                        />
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
    </oss-dialog>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import ossCompanySelector from "../ossComponents/ossCompanySelector.vue";
import SelectUser from "../user/SelectUser.vue";

import ACCOUNTING_COMPANY_OF_COMPANY from "../../graphql/company/AccountingCompanyOfCompany.gql";
import UPSERT_TASK from "../../graphql/tasks/UpsertTasks.gql";

import { getDBFormattedDate } from "@/services/dateServices";
import { Component, Vue, Model, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { getUserDisplayName } from "@/services/userServices";

@Component({
    components: {
        SelectUser,
        ossCompanySelector,
    },
    emits: ["task-created"],
})
export class TaskDialog extends Vue {
    @Prop({ default: "" }) taskDate: string;
    @Prop({ default: false }) isNewTask: boolean;
    @Prop({ default: false }) isEditTask: boolean;
    @Prop() taskToEdit: any;
    @Prop() tasksDatabase: any;
    @Model() value: boolean;

    windowStep = "default";

    taskValid = false;
    isNewTaskReceive = false;
    isEditTaskReceive = false;

    currentDate = new Date();

    userTextField = "";
    dueDateFormat = "";
    endFormat = "";
    startFormat = "";
    periodicityEndDateFormat = "";
    selectUserStep = "selectUser";

    typeStatus = [
        { value: "TO_BE_DONE", name: "En cours" },
        { value: "DONE", name: "Terminée" },
    ];

    type = [
        { value: "MISCELLANEOUS", name: "Divers" },
        { value: "IS", name: "IS" },
    ];

    periodicity = [
        { value: null, name: "Aucune" },
        { value: "MONTHLY", name: "Mensuel" },
        { value: "QUARTERLY", name: "Trimestriel" },
        { value: "ANNUAL", name: "Annuel" },
    ];

    task = {
        id: "",
        start: "",
        end: "",
        periodicity: null,
        dueDate: "",
        title: "",
        description: "",
        owner: this.currentUser,
        type: "MISCELLANEOUS",
        status: "TO_BE_DONE",
        members: [],
        auto: null,
        client: {
            id: "",
            name: "",
        },
        tasks: [],
        recurringTask: {
            id: "",
        },
    };

    taskDeleleteIds = [];

    selectedUsers = [];

    beforeMount() {
        // debugger
        this.isNewTaskReceive = this.isNewTask;
        this.isEditTaskReceive = this.isEditTask;

        if (this.isEditTaskReceive && !this.isNewTaskReceive) {
            this.task = JSON.parse(JSON.stringify(this.taskToEdit));
        }

        if (this.taskDate) {
            this.task.dueDate = this.taskDate;
            this.task.start = this.taskDate;
        } else {
            this.task.dueDate = getDBFormattedDate(this.currentDate);
            this.task.start = getDBFormattedDate(this.currentDate);
        }

        // this.selectedCompany;
        this.updateSelectedCompany();
    }

    get selectedCompany() {
        return this.$store?.state.selected_company;
    }

    @Watch("selectedCompany", { deep: true })
    updateSelectedCompany() {
        if (this.selectedCompany) {
            this.task.client = this.selectedCompany;
        }

        return this.task.client;
    }

    get allAvailableCompanies() {
        return this.$store?.state.user.allAvailableCompanies;
    }

    get currentUser(): User {
        return this.$store?.state.user;
    }

    get companyId() {
        if (this.isAccountingUser && this.currentUser?.company?.id) {
            return this.currentUser.company.id;
        }
        if (!this.isAccountingUser && this.accountingFirm) {
            return this.accountingFirm.id;
        }
        return "";
    }

    get taskId() {
        return this.tasksDatabase.id || "";
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isValid() {
        switch (this.windowStep) {
            case "default":
                return this.isNewTaskReceive ? this.taskValid : true;
            case "usersChoice":
                return true;
            // default:
            //     return true
        }
        return false;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser.id || this.isAccountingUser;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.accountingFirm = data.companies[0];
                }
            }
        },
    })
    accountingFirm = null;

    async valid() {
        if (this.windowStep === "default") {
            if (this.selectedUsers) {
                this.task.members = this.selectedUsers.map((selectedUser) => ({
                    id: selectedUser.id,
                }));
            }

            this.dueDateFormat = getDBFormattedDate(this.task.dueDate);

            // Condition selon si on a sélectionné tâche récurrentes
            if (this.task.periodicity === null || this.task.periodicity === "Aucune") {
                this.startFormat = getDBFormattedDate(this.task.dueDate);
                this.endFormat = getDBFormattedDate(this.task.dueDate);
            } else {
                this.startFormat = getDBFormattedDate(this.task.start);
                this.endFormat = getDBFormattedDate(this.task.end);
            }

            if (this.isNewTaskReceive || this.isEditTaskReceive) {
                await this.upsertTask();
                this.emptyTask();
                this.isNewTaskReceive = false;
                this.isEditTaskReceive = false;
                this.dialog = false;
            }
        }
    }

    async upsertTask() {
        if (this.isNewTaskReceive) {
            let newTask: any = null;

            // debugger
            newTask = await this.$apollo.mutate({
                mutation: UPSERT_TASK,
                variables: {
                    company: this.companyId,
                    client: this.task.client.id,
                    title: this.task.title,
                    description: this.task.description,
                    type: this.task.type,
                    status: this.task.status,
                    start: this.startFormat,
                    end: this.endFormat,
                    periodicity: this.task.periodicity,
                    dueDate: this.dueDateFormat,
                    owner: this.task.owner.id,
                    membersCreate: { connect: this.task.members },
                },
            });

            this.$emit("task-created");

            if (newTask.data && newTask.data.upsertTask) {
                this.tasksDatabase.id = newTask.data.upsertTask.id;
                this.$emit("task-created");
            }
        }

        //Edit
        else {
            if (!(this.task.id === "")) {
                // debugger
                this.dueDateFormat = getDBFormattedDate(this.task.dueDate);

                if (this.task.periodicity === null || this.task.periodicity === "Aucune") {
                    this.startFormat = getDBFormattedDate(this.task.dueDate);
                    this.endFormat = getDBFormattedDate(this.task.dueDate);
                } else {
                    this.startFormat = getDBFormattedDate(this.task.start);
                    this.endFormat = getDBFormattedDate(this.task.end);
                }

                if (this.task.recurringTask) {
                    // Update Regular Task

                    await this.$apollo.mutate({
                        mutation: UPSERT_TASK,
                        variables: {
                            id: this.task.id,
                            title: this.task.title,
                            owner: this.task.owner.id,
                            company: this.companyId,
                            client: this.task.client.id,
                            description: this.task.description,
                            type: this.task.type,
                            status: this.task.status,
                            dueDate: this.dueDateFormat,
                            start: this.startFormat,
                            end: this.endFormat,
                            membersCreate: { connect: this.task.members },
                            membersUpdate: { set: this.task.members },
                            periodicity: this.task.periodicity,
                            recurringTask: this.task.recurringTask.id,
                        },
                    });
                } else {
                    // Update Recurring Task

                    for (const taskOfRecurringTask of this.task.tasks) {
                        this.taskDeleleteIds.push(taskOfRecurringTask.id);
                    }

                    // await this.$apollo.mutate({
                    //     mutation: DELETE_TASK,
                    //     variables:{
                    //         ids: this.taskDeleleteIds
                    //     }
                    // })
                    // this.taskDeleleteIds = []

                    await this.$apollo.mutate({
                        mutation: UPSERT_TASK,
                        variables: {
                            id: this.task.id,
                            title: this.task.title,
                            owner: this.task.owner.id,
                            company: this.companyId,
                            client: this.task.client.id,
                            description: this.task.description,
                            type: this.task.type,
                            status: this.task.status,
                            dueDate: this.dueDateFormat,
                            start: this.startFormat,
                            end: this.endFormat,
                            membersCreate: { connect: this.task.members },
                            membersUpdate: { set: this.task.members },
                            periodicity: this.task.periodicity,
                            tasks: this.taskDeleleteIds.length
                                ? { id_in: this.taskDeleleteIds }
                                : null,
                        },
                    });
                }
                this.$emit("task-created");
            }
        }
    }

    previous() {
        switch (this.windowStep) {
            case "usersChoice":
                if (this.selectUserStep === "selectUser") {
                    this.windowStep = "default";
                }
                if (this.selectUserStep === "createUser") {
                    this.selectUserStep = "selectUser";
                }
            case "default":
                break;
        }
    }

    close() {
        // debugger
        // this.taskDate = ""
        this.emptyTask();
        this.dialog = false;
        this.previous();
    }

    openUsersChoice() {
        this.windowStep = "usersChoice";
    }

    checkPeriodicity() {
        if (this.task.periodicity === null) {
            return false;
        }
        if (this.task.periodicity === "") {
            return false;
        }

        return true;
    }

    formatUserTaskFrom(owner) {
        // debugger
        if (owner) {
            return owner.firstname + " " + owner.lastname;
        }
        return "";
    }

    readOnlyFieldDialog() {
        // debugger

        if (this.isEditTaskReceive) {
            if (this.task?.recurringTask && this.task?.recurringTask?.id !== "") {
                return true;
            }
        }

        return false;
    }

    emptyTask() {
        // debugger
        if (this.isNewTaskReceive) {
            let taskEnd = "";
            // debugger
            if (this.taskDate) {
                taskEnd = this.taskDate;
            }
            this.task = {
                id: "",
                start: taskEnd,
                end: taskEnd,
                dueDate: "",
                periodicity: "",
                title: "",
                auto: false,
                owner: this.currentUser,
                type: "",
                status: "",
                description: "",
                members: [],
                client: this.task.client,
                tasks: [],
                recurringTask: {
                    id: "",
                },
            };
            this.selectedUsers = [];
            this.isNewTaskReceive = false;
            // Cas lorsque on clique sur une tâche pour l'edition
        } else if (this.isEditTaskReceive) {
            // debugger
            this.task = {
                id: "",
                start: "",
                end: "",
                periodicity: "",
                dueDate: "",
                title: "",
                auto: false,
                owner: this.currentUser,
                type: "",
                status: "",
                description: "",
                members: [],
                client: this.task.client,
                tasks: [],
                recurringTask: {
                    id: "",
                },
            };
            this.isEditTaskReceive = false;
            this.selectedUsers = [];
        }
    }

    @Watch("isEditTaskReceive")
    editTask() {
        // debugger
        if (this.isEditTaskReceive) {
            this.task = JSON.parse(JSON.stringify(this.taskToEdit));
            this.selectedUsers = this.task.members;
        }
    }

    get valueButton() {
        // debugger
        if (this.isNewTaskReceive === true) {
            return "Ajouter";
        } else {
            if (this.windowStep === "default") {
                return "Modifier";
            }
        }
        return "Ajouter";
    }

    get readOnly() {
        if (this.task.auto === true) {
            return true;
        }

        return false;
    }

    @Watch("taskDate")
    receiveDateFromCalendar() {
        let taskDate = "";

        if (this.taskDate) {
            taskDate = this.taskDate;
            this.selectedUsers = [];
            this.task.start = taskDate;
            this.task.end = taskDate;
        }
    }

    @Watch("selectedUsers", { deep: true })
    receiveSelectedUsers() {
        debugger;
        if (this.selectedUsers) {
        }
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }
}

export default toNative(TaskDialog);
</script>
